<template>
  <div
    class="rounded-t border"
    :class="{
      'bg-gray-100 border-action rounded': isRunning,
      'bg-red-100 border-red-800 rounded': error,
      'bg-green-100 border-green-600 rounded': attempt.success,
    }"
  >
    <div class="px-2 py-1 flex justify-between text-black items-center">
      <div>
        {{ attempt.file.name }}
        <small class="text-gray-700">{{
          humanFileSize(attempt.file.size)
        }}</small>
      </div>
      <div v-if="isRunning">
        <font-awesome-icon
          v-if="attempt.paused"
          icon="pause-circle"
          size="lg"
          class="text-action"
        />
        <font-awesome-icon v-else icon="spinner" spin />
      </div>
      <div
        v-else-if="error"
        class="text-xs w-5 h-5 rounded-full bg-red-800 flex justify-center items-center text-white"
      >
        <font-awesome-icon icon="exclamation" />
      </div>
      <div
        v-else-if="attempt.success"
        class="text-xs w-5 h-5 rounded-full bg-green-600 flex justify-center items-center text-white"
      >
        <font-awesome-icon icon="check" />
      </div>
    </div>
    <div
      v-if="attempt.project_id && attempt.project_id != project.id"
      class="px-2"
    >
      <small class="text-gray-700"
        >{{ i18n.project_id_reused }}&nbsp;&nbsp;</small
      >
      <router-link
        :to="{
          name: 'project.index',
          params: {
            id: attempt.project_id,
            locale: $route.params.locale,
            type: $route.params.type,
          },
        }"
        class="hover:underline"
        >{{ attempt.project_id }}</router-link
      >
    </div>
    <div v-if="error" class="text-red-800">
      <p class="pb-1 px-2">
        {{ translatedError }}
      </p>
    </div>
    <small v-if="attempt.success" class="block px-2 text-gray-700">{{
      i18n.project_sent_to_validation
    }}</small>
    <div v-else-if="attempt.upload" class="relative h-6 bg-gray-200 rounded-b">
      <div
        v-if="attempt.progress"
        class="absolute bottom-0 h-1 w-5 bg-action rounded-bl"
        :style="{
          width:
            (100 * attempt.progress.bytesUploaded) /
              attempt.progress.bytesTotal +
            '%',
        }"
      />
      <div class="w-full px-2 bottom- flex items-end justify-between">
        <button
          @click="attempt.upload.start"
          v-if="attempt.error"
          class="text-xs px-2 h-5 rounded-full bg-gray-100 hover:bg-blue-200 border border-blue-700 inline-flex justify-center items-center text-blue-900"
        >
          <font-awesome-icon icon="redo-alt" class="mr-1" />
          {{ i18n.retry }}
        </button>
        <button
          v-else-if="attempt.paused"
          @click="attempt.upload.start"
          class="text-xs px-2 h-5 rounded-full bg-gray-100 hover:bg-menu-hover border border-action inline-flex justify-center items-center text-gray-800"
        >
          <span class="text-sm text-gray-800 mr-2 -mt-1">▶</span>
          {{ i18n.resume }}
        </button>
        <button
          v-else
          @click="attempt.upload.pause"
          class="text-xs px-2 h-5 rounded-full bg-gray-100 hover:bg-menu-hover border border-action inline-flex justify-center items-center text-gray-800"
        >
          <span class="text-sm text-gray-800 mr-1">⏸︎</span>
          {{ i18n.pause }}
        </button>
        <small v-if="attempt.progress" class="text-gray-700">
          <span v-if="attempt.progress.speed && !attempt.paused">
            {{ humanFileSpeed(attempt.progress.speed) }}
            &nbsp;&middot;
          </span>
          &nbsp;
          {{
            Math.round(
              (100 * attempt.progress.bytesUploaded) /
                attempt.progress.bytesTotal
            )
          }}%
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["attempt", "project"],
  methods: {
    humanFileSize(size) {
      if (size <= 0) {
        return "0 B";
      }
      var i = Math.floor(Math.log(size) / Math.log(1024));
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "KB", "MB", "GB", "TB"][i]
      );
    },
    humanFileSpeed(speed) {
      return this.humanFileSize(speed * 8).replace(/B$/, "b/s");
    },
  },
  computed: {
    ...mapState({
      i18n: (state) => state.upload.i18n,
    }),
    error() {
      return this.attempt.error;
    },
    isRunning() {
      return !this.attempt.error && !this.attempt.success;
    },
    translatedError() {
      if (this.error.message) {
        return this.error.message;
      }
      if (this.error.key) {
        return this.i18n.errors[this.error.key] || this.error.key;
      }
      return this.error;
    },
  },
  watch: {
    ["attempt.upload"](up) {
      this.$emit("upload-route", up.route);
    },
  },
};
</script>
